import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FREELANCER_HTTP_CONFIG } from './freelancer-http.config';
import { FreelancerHttpConfig } from './freelancer-http.interface';
import { FreelancerHttp } from './freelancer-http.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [FreelancerHttp],
})
export class FreelancerHttpModule {
  static initialize(config: FreelancerHttpConfig): ModuleWithProviders {
    return {
      ngModule: FreelancerHttpModule,
      providers: [{ provide: FREELANCER_HTTP_CONFIG, useValue: config }],
    };
  }
}
